import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './index.css';
import 'typeface-roboto';
import 'typeface-roboto-slab';
import App from './containers/App';
import {MuiThemeProvider} from '@material-ui/core/styles';
import {BrowserRouter} from 'react-router-dom';
import theme from './static/theme';

ReactDOM.render(
  <MuiThemeProvider theme={theme}>
    <BrowserRouter>
      <App/>
    </BrowserRouter>
  </MuiThemeProvider>, document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
